import React from 'react';

export default function BankIdInstructions() {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center'
    }}>
      <div style={{
        margin: "1em", 
        maxWidth: '600px',
        width: '100%' 
      }}>
        <img
          src="/static/Instructor-Portal_App-logo_DESKTOP.png"
          alt="BankID Instructions"
          style={{margin: "2em 0 2em 0"}}
        />

        <section>
          <h2 style={{ fontSize: '1.4rem', marginTop: '10px', marginBottom: '10px' }}>
            Om BankID inte öppnar i Samsung Internet
          </h2>
          <p>Följ stegen nedan för att lösa problemet:</p>
          <ol style={{ paddingLeft: '1.2rem' }}>
            <li>Gå till inställningar på telefonen (Kugghjulet).</li>
            <li>Välj Appar och klicka på “Samsungs appinställningar”.</li>
            <li>Scrolla ner och klicka in på “Samsung internet”.</li>
            <li>I inställningarna för internet väljer du “Användbara Funktioner”.</li>
            <li>Dra reglaget för “Öppna applänkar i webbläsaren” till vänster så att det är avstängt.</li>
          </ol>
        </section>

        <section style={{ marginTop: '20px' }}>
          <h2 style={{ fontSize: '1.4rem', marginBottom: '10px' }}>
            Om BankID inte öppnar på Androidenhet
          </h2>
          <p>Följ stegen nedan för att lösa problemet:</p>
          <ol style={{ paddingLeft: '1.2rem' }}>
            <li>Öppna inställningar.</li>
            <li>Gå till Appar -{'>'} Välj standardappar -{'>'} Öppna länkar.</li>
            <li>Klicka på BankID i listan.</li>
            <li>Slå på valet ”Öppna länkar som stöds”.</li>
          </ol>
        </section>

        <section style={{ marginTop: '20px' }}>
          <h2 style={{ fontSize: '1.4rem', marginBottom: '10px' }}>
            Om BankID inte öppnar på Appleenhet
          </h2>
          <p>Följ stegen nedan för att lösa problemet om du inte har Safari som standardwebbläsare:</p>
          <ol style={{ paddingLeft: '1.2rem' }}>
            <li>Öppna inställningar.</li>
            <li>Gå till Safari -{'>'} Förvald app för webbläsare.</li>
            <li>Välj Safari.</li>
          </ol>
        </section>
      </div>
    </div>
  );
}